import React, { useState, useEffect } from 'react';
import api, { assetUrl } from '../services/api';

const SimpleHeroTest: React.FC = () => {
  const [message, setMessage] = useState('Loading...');
  const [cards, setCards] = useState<any[]>([]);

  useEffect(() => {
    const test = async () => {
      try {
        setMessage('Testing API...');
        console.log('🧪 Starting API test...');
        
        const response = await api.heroApi.getAll();
        console.log('📡 Raw response:', response);
        
        const data = response.data || [];
        console.log('📦 Data:', data);
        
        const activeCards = data.filter((card: any) => card.is_active === true);
        console.log('✅ Active cards:', activeCards);
        
        const processedCards = activeCards.map((card: any) => ({
          id: card.id,
          heading: card.heading,
          image: assetUrl(card.background_image || card.image)
        }));
        
        setCards(processedCards);
        setMessage(`✅ Found ${processedCards.length} active cards`);
        
        processedCards.forEach((card, index) => {
          console.log(`Card ${index + 1}: ${card.heading} - ${card.image}`);
        });
        
      } catch (error) {
        console.error('❌ Test failed:', error);
        setMessage(`❌ Error: ${error}`);
      }
    };

    test();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white p-8">
      <h1 className="text-4xl font-bold mb-4">Simple Hero Test</h1>
      <p className="text-xl mb-8">{message}</p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card) => (
          <div key={card.id} className="border border-white/20 rounded-lg p-4">
            <h3 className="text-xl font-semibold mb-2">{card.heading}</h3>
            <div className="w-full h-48 bg-gray-800 rounded-lg overflow-hidden mb-4">
              <img 
                src={card.image} 
                alt={card.heading}
                className="w-full h-full object-cover"
                onError={(e) => {
                  console.error(`❌ Image failed: ${card.image}`);
                  (e.target as HTMLImageElement).style.backgroundColor = 'red';
                }}
                onLoad={() => {
                  console.log(`✅ Image loaded: ${card.image}`);
                }}
              />
            </div>
            <p className="text-sm text-gray-400">{card.image}</p>
          </div>
        ))}
      </div>
      
      {cards.length === 0 && (
        <div className="text-center text-gray-400">
          <p>No cards found</p>
        </div>
      )}
    </div>
  );
};

export default SimpleHeroTest;
